// Slice template di risposta. La tabella `gmail_reply_templates` e` CONDIVISA
// tra provider, quindi resta nella factory (accesso diretto a supabase, NON
// tramite adapter). Logica identica a gmailStore.ts.
import { supabase } from '../../../supabase';
import type { MailAdapter } from '../mailAdapter';
import type { MailActions, MailSet, MailGet } from '../storeTypes';

type TemplateSlice = Pick<MailActions, 'loadTemplates' | 'createTemplate' | 'updateTemplate' | 'deleteTemplate'>;

export function createTemplateSlice(set: MailSet, get: MailGet, adapter: MailAdapter): TemplateSlice {
  const LOG = `[mailStore:${adapter.provider}]`;
  return {
    loadTemplates: async (organizationId) => {
      set({ templatesLoading: true });
      try {
        const { data, error } = await supabase
          .from('gmail_reply_templates')
          .select('*')
          .eq('organization_id', organizationId)
          .order('sort_order', { ascending: true });

        if (error) throw error;
        set({ templates: data || [], templatesLoading: false });
      } catch (error: any) {
        console.error(`${LOG} Load templates error:`, error);
        set({ templatesLoading: false });
      }
    },

    createTemplate: async (template) => {
      try {
        const { error } = await supabase
          .from('gmail_reply_templates')
          .insert(template);

        if (error) throw error;

        if (template.organization_id) {
          await get().loadTemplates(template.organization_id);
        }
      } catch (error: any) {
        console.error(`${LOG} Create template error:`, error);
        throw error;
      }
    },

    updateTemplate: async (id, updates) => {
      try {
        const { error } = await supabase
          .from('gmail_reply_templates')
          .update({ ...updates, updated_at: new Date().toISOString() })
          .eq('id', id);

        if (error) throw error;

        set({
          templates: get().templates.map(t => t.id === id ? { ...t, ...updates } : t),
        });
      } catch (error: any) {
        console.error(`${LOG} Update template error:`, error);
        throw error;
      }
    },

    deleteTemplate: async (id) => {
      try {
        const { error } = await supabase
          .from('gmail_reply_templates')
          .delete()
          .eq('id', id);

        if (error) throw error;

        set({ templates: get().templates.filter(t => t.id !== id) });
      } catch (error: any) {
        console.error(`${LOG} Delete template error:`, error);
        throw error;
      }
    },
  };
}
